import { handleHideModal } from 'components/global/_helpers/global.helpers';
import InvestorPortfolioForm from 'components/global/InvestorPortfolioForm';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitCreatePortfolio } from 'components/views/InvestorPortfolioList/_helpers/investorPortfolioList.events';
import { $view } from 'signals/global.signals';

const InvestorPortfolioAddModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-portfolio-add'}
    title="Add Portfolio Entry"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreatePortfolio}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <InvestorPortfolioForm />
  </SimpleModal>

);

export default InvestorPortfolioAddModal;
